import React from "react";
import PublicLayout from "../components/layout/PublicLayout";
import { Card } from "../components/ui/card";
import { Search, ShieldCheck, KeyRound, Wallet, Globe2 } from "lucide-react";

export default function HowItWorks() {
  const steps = [
    { i: Search, t: "Search the marketplace", d: "Filter by city, dates, transmission, fuel and price. Compare prices in your currency." },
    { i: ShieldCheck, t: "Book your car", d: "Every car & owner is verified manually. Transparent pricing with the exchange rate shown before you pay." },
    { i: KeyRound, t: "Meet the owner & drive", d: "Pick up the keys from your verified host and start your trip across Rwanda." },
    { i: Wallet, t: "Pay your way", d: "Mobile Money (MTN / Airtel) or local & international cards — all via UrubutoPay, all in RWF." },
    { i: Globe2, t: "Multi-currency, always honest", d: "Listings are in the owner's currency; you see your local total at checkout — no hidden FX margin." },
  ];
  return (
    <PublicLayout>
      <section className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[10px] uppercase tracking-[0.2em] text-accent font-bold mb-3">How it works</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tighter">Simple, transparent, made for East Africa.</h1>
        <p className="mt-4 text-muted-foreground max-w-2xl leading-relaxed">RydeXpress is a peer-to-peer marketplace. We connect renters with verified owners, handle the payment, and stay out of the way.</p>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {steps.map((s, i) => (
            <Card key={i} className="border-border p-6 fade-up" style={{ animationDelay: `${i * 60}ms` }}>
              <div className="w-10 h-10 rounded-md bg-primary text-primary-foreground flex items-center justify-center mb-4">
                <s.i size={18} />
              </div>
              <h3 className="font-display text-xl font-semibold tracking-tight">{s.t}</h3>
              <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{s.d}</p>
            </Card>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
